export default __webpack_public_path__ + "6f7faf23d5d455eef563fbf31f39b0c4.png";